import { createRouter, createWebHistory } from 'vue-router';
import FrontLayout from '@/components/FrontLayout';
import DashboardLayout from '@/components/DashboardLayout';
import store from '@/store';
import Toast from '@/plugins/toast';
const routes = [
  {
    path: '/card-print/:id/:type/:user_id',
    meta: {requiresAuth: true,hasProfile: store.state.user.has_profile},
    name: 'CardPrint',
    component: () => import(/* webpackChunkName: "card-print" */ '@/views/Panel/CardPrint.vue')
  },

  {
    path: '/qr-code/:type/:user/:post_slug',
    name: 'Qrcode',
    component: () => import(/* webpackChunkName: "qr-code" */ '@/views/Front/Qrcode.vue')
  },
  {
    path: '/certificate/:type/:user/:post_slug',
    name: 'CertificateInfo',
    component: () => import(/* webpackChunkName: "certificate" */ '@/views/Front/CertificateInfo.vue')
  },


  {
    path: '/:slug?',
    component: FrontLayout,
    children:[
      {
        path: '/:slug?',
        name: 'Index',
        component: () => import(/* webpackChunkName: "index" */ '@/views/Front/Index.vue')
      },
      {
        path: '/payment-alert',
        name: 'paymentAlert',
        component: () => import(/* webpackChunkName: "payment-alert" */ '@/views/Front/paymentAlert.vue')
      },

      {
        path: '/course-categories/:slug',
        name: 'CourseCategory',
        component: () => import(/* webpackChunkName: "course-categories" */ '@/views/Front/CourseCategory.vue')
      },
      {
        path: '/course-detail/:slug',
        name: 'CourseDetail',
        component: () => import(/* webpackChunkName: "course-detail" */ '@/views/Front/CourseDetail.vue')
      },
      {
        path: '/article-list/:slug',
        name: 'ArticleList',
        component: () => import(/* webpackChunkName: "article-list" */ '@/views/Front/ArticleList.vue')
      },
      {
        path: '/article-detail/:slug',
        name: 'ArticleDetail',
        component: () => import(/* webpackChunkName: "article-detail" */ '@/views/Front/ArticleDetail.vue')
      },
      {
        path: '/event-list/:slug',
        name: 'EventList',
        component: () => import(/* webpackChunkName: "event-list" */ '@/views/Front/EventList.vue')
      },
      {
        path: '/event-detail/:slug',
        name: 'EventDetail',
        component: () => import(/* webpackChunkName: "event-detail" */ '@/views/Front/EventDetail.vue')
      },
      {
        path: '/contactus',
        name: 'ContactUsPage',
        component: () => import(/* webpackChunkName: "contactus" */ '@/views/Front/ContactUsPage.vue')
      },
      {
        path: '/about-us',
        name: 'AboutUs',
        component: () => import(/* webpackChunkName: "about-us" */ '@/views/Front/AboutUs.vue')
      },
      {
        path: '/error/:status/:msg',
        name: 'Error',
        component: () => import(/* webpackChunkName: "error" */ '@/views/Front/Error.vue')
      },
      {
        path: '/login',
        name: 'Login',
        meta: { requiresLogin: true },
        component: () => import(/* webpackChunkName: "login" */ '@/views/Auth/Login.vue')
      },
      {
        path: '/forgot/password',
        name: 'ForgotPassword',
        meta: { requiresLogin: true },
        component: () => import(/* webpackChunkName: "forgot/password" */ '@/views/Auth/ForgotPassword.vue')
      },
    ]
  },

  {
    path: '/dashboard',
    meta: {requiresAuth: true},
    component: DashboardLayout,
    children: [
      {
        path: '/dashboard',
        meta: {hasProfile: store.state.user.has_profile},
        name: 'Dashboard',
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/Panel/Dashboard.vue')
      },
      {
        path: '/categories',
        meta: {hasProfile: store.state.user.has_profile},
        name: 'Category',
        component: () => import(/* webpackChunkName: "category" */ '@/views/Panel/Category.vue')
      },
      {
        path: '/users',
        meta: {hasProfile: store.state.user.has_profile},
        name: 'User',
        component: () => import(/* webpackChunkName: "users" */ '@/views/Panel/User.vue')
      },
      {
        path: '/roles',
        meta: {hasProfile: store.state.user.has_profile},
        name: 'Role',
        component: () => import(/* webpackChunkName: "roles" */ '@/views/Panel/Role.vue')
      },
      {
        path: '/permissions',
        meta: {hasProfile: store.state.user.has_profile},
        name: 'Permission',
        component: () => import(/* webpackChunkName: "permissions" */ '@/views/Panel/Permission.vue')
      },
      {
        path: '/courses',
        meta: {hasProfile: store.state.user.has_profile},
        name: 'Course',
        component: () => import(/* webpackChunkName: "courses" */ '@/views/Panel/Course.vue')
      },
      {
        path: '/course-requests',
        meta: {hasProfile: store.state.user.has_profile},
        name: 'CourseRequest',
        component: () => import(/* webpackChunkName: "course-requests" */ '@/views/Panel/CourseRequest.vue')
      },
      {
        path: '/financial_documents',
        meta: {hasProfile: store.state.user.has_profile},
        name: 'FinancialDocument',
        component: () => import(/* webpackChunkName: "financial_documents" */ '@/views/Panel/FinancialDocument.vue')
      },
      {
        path: '/profile',
        name: 'Profile',
        component: () => import(/* webpackChunkName: "profile" */ '@/views/Panel/Profile.vue')
      },
      {
        path: '/change-password',
        meta: {hasProfile: store.state.user.has_profile},
        name: 'ChangePassword',
        component: () => import(/* change-password: "change-password" */ '@/views/Panel/ChangePassword.vue')
      },
      {
        path: '/course-completed',
        meta: {hasProfile: store.state.user.has_profile},
        name: 'CourseCompleted',
        component: () => import(/* change-password: "course-completed" */ '@/views/Panel/CourseCompleted.vue')
      },
      {
        path: '/ticket-categories',
        meta: {hasProfile: store.state.user.has_profile},
        name: 'TicketCategory',
        component: () => import(/* webpackChunkName: "ticket-categories" */ '@/views/Panel/TicketCategory.vue')
      },
      {
        path: '/tickets',
        meta: {hasProfile: store.state.user.has_profile},
        name: 'Ticket',
        component: () => import(/* webpackChunkName: "tickets" */ '@/views/Panel/Ticket.vue')
      },
      {
        path: '/sms-messages',
        meta: {hasProfile: store.state.user.has_profile},
        name: 'SmsMessage',
        component: () => import(/* webpackChunkName: "sms-messages" */ '@/views/Panel/SmsMessage.vue')
      },
      {
        path: '/entry-cards',
        meta: {hasProfile: store.state.user.has_profile},
        name: 'EntryCard',
        component: () => import(/* webpackChunkName: "entry-cards" */ '@/views/Panel/EntryCard.vue')
      },

      {
        path: '/my-cards',
        meta: {hasProfile: store.state.user.has_profile},
        name: 'MyCourseCard',
        component: () => import(/* webpackChunkName: "my-cards" */ '@/views/Panel/MyCourseCard.vue')
      },
      {
        path: '/my-events',
        meta: {hasProfile: store.state.user.has_profile},
        name: 'MyEventCard',
        component: () => import(/* webpackChunkName: "my-events" */ '@/views/Panel/MyEventCard.vue')
      },

      {
        path: '/my-student-course-card',
        meta: {hasProfile: store.state.user.has_profile},
        name: 'MyStudentCourseCard',
        component: () => import(/* webpackChunkName: "my-student-course-card" */ '@/views/Panel/MyStudentCourseCard.vue')
      },
      {
        path: '/my-student-event-card',
        meta: {hasProfile: store.state.user.has_profile},
        name: 'MyStudentEventCard',
        component: () => import(/* webpackChunkName: "my-student-event-card" */ '@/views/Panel/MyStudentEventCard.vue')
      },

      {
        path: '/sliders',
        meta: {hasProfile: store.state.user.has_profile},
        name: 'Slider',
        component: () => import(/* webpackChunkName: "sliders" */ '@/views/Panel/Slider.vue')
      },
      {
        path: '/article',
        meta: {hasProfile: store.state.user.has_profile},
        name: 'Article',
        component: () => import(/* webpackChunkName: "article" */ '@/views/Panel/Article.vue')
      },
      {
        path: '/comments',
        meta: {hasProfile: store.state.user.has_profile},
        name: 'Comment',
        component: () => import(/* webpackChunkName: "comments" */ '@/views/Panel/Comment.vue')
      },
      {
        path: '/contact-us',
        name: 'ContactUs',
        component: () => import(/* webpackChunkName: "contact-us" */ '@/views/Panel/ContactUs.vue')
      },

      {
        path: '/site-configs',
        meta: {hasProfile: store.state.user.has_profile},
        name: 'SiteConfig',
        component: () => import(/* webpackChunkName: "site-configs" */ '@/views/Panel/SiteConfig.vue')
      },

      {
        path: '/events',
        meta: {hasProfile: store.state.user.has_profile},
        name: 'Event',
        component: () => import(/* webpackChunkName: "events" */ '@/views/Panel/Event.vue')
      },
      {
        path: '/orders',
        meta: {hasProfile: store.state.user.has_profile},
        name: 'Order',
        component: () => import(/* webpackChunkName: "orders" */ '@/views/Panel/Order.vue')
      },
      {
        path: '/transactions',
        meta: {hasProfile: store.state.user.has_profile},
        name: 'Transaction',
        component: () => import(/* webpackChunkName: "transactions" */ '@/views/Panel/Transaction.vue')
      },
      {
        path: '/certificate-templates',
        meta: {hasProfile: store.state.user.has_profile},
        name: 'CertificateTemplate',
        component: () => import(/* webpackChunkName: "certificate-templates" */ '@/views/Panel/CertificateTemplate.vue')
      },
      {
        path: '/template-fonts',
        meta: {hasProfile: store.state.user.has_profile},
        name: 'TemplateFont',
        component: () => import(/* webpackChunkName: "template-fonts" */ '@/views/Panel/TemplateFont.vue')
      },
      {
        path: '/event-completed',
        meta: {hasProfile: store.state.user.has_profile},
        name: 'EventCompleted',
        component: () => import(/* webpackChunkName: "event-completed" */ '@/views/Panel/EventCompleted.vue')
      },
      {
        path: '/my-course-certificates',
        meta: {hasProfile: store.state.user.has_profile},
        name: 'MyCourseCertificate',
        component: () => import(/* webpackChunkName: "my-course-certificates" */ '@/views/Panel/MyCourseCertificate.vue')
      },
      {
        path: '/my-event-certificates',
        meta: {hasProfile: store.state.user.has_profile},
        name: 'MyEventCertificate',
        component: () => import(/* webpackChunkName: "my-event-certificates" */ '@/views/Panel/MyEventCertificate.vue')
      },
      {
        path: '/my-student-course-certificates',
        meta: {hasProfile: store.state.user.has_profile},
        name: 'MyStudentCourseCertificate',
        component: () => import(/* webpackChunkName: "my-student-course-certificates" */ '@/views/Panel/MyStudentCourseCertificate.vue')
      },
      {
        path: '/my-student-event-certificates',
        meta: {hasProfile: store.state.user.has_profile},
        name: 'MyStudentEventCertificate',
        component: () => import(/* webpackChunkName: "my-student-event-certificates" */ '@/views/Panel/MyStudentEventCertificate.vue')
      },
      {
        path: '/discount',
        meta: {hasProfile: store.state.user.has_profile},
        name: 'Discount',
        component: () => import(/* webpackChunkName: "discount" */ '@/views/Panel/Discount.vue')
      },
      {
        path: '/installment-plans',
        meta: {hasProfile: store.state.user.has_profile},
        name: 'InstallmentPlan',
        component: () => import(/* webpackChunkName: "installment-plans" */ '@/views/Panel/InstallmentPlan.vue')
      },
      {
        path: '/gift-packages',
        meta: {hasProfile: store.state.user.has_profile},
        name: 'GiftPackage',
        component: () => import(/* webpackChunkName: "gift-packages" */ '@/views/Panel/GiftPackage.vue')
      },

      {
        path: '/event-service',
        meta: {hasProfile: store.state.user.has_profile},
        name: 'EventService',
        component: () => import(/* webpackChunkName: "event-service" */ '@/views/Panel/EventService.vue')
      },
      {
        path: '/manager-requests',
        meta: {hasProfile: store.state.user.has_profile},
        name: 'ManagerRequest',
        component: () => import(/* webpackChunkName: "manager-requests" */ '@/views/Panel/ManagerRequest.vue')
      },
      {
        path: '/sms-panel-charge',
        meta: {hasProfile: store.state.user.has_profile},
        name: 'SmsPanelCharge',
        component: () => import(/* webpackChunkName: "sms-panel-charge" */ '@/views/Panel/SmsPanelCharge.vue')
      },
    ]

  },

  { path: "/error/404/صفحه مورد نظر پیدا نشد", component: 'Error' }

]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior () {
    return { top: 0 };
  }
})

async function checkExpireCookie(){
  let expireAt = parseInt(store.getters.getCookie('expire_token'));
  let now = (new Date()).getTime();
  expireAt = isNaN(expireAt) ? now : expireAt;
  if(expireAt > now ){
    await store.dispatch('setCookie', 'expire_token')
  }else{
    store.commit('clearStorage')
  }
  // expireAt > now ? await store.dispatch('setCookie', 'expire_token') : store.commit('clearStorage')
}

router.beforeEach(async (to,from,next)=>{
  await checkExpireCookie();
  if(to.matched[0].path === '/dashboard'){
    store.state.toggleAside = false;
  }else{
    store.state.toggleNav = false;
  }
  if(to.matched.length <= 0){
    next({name:'Error', params:{status:'404', msg:'صفحه مورد نظر پیدا نشد'}})
  }
  let hasProfile = to.meta.hasProfile !== 'false';
  if(!to.matched.length && to.fullPath !== '/'){
    next({name:'Error',params:{status:404,msg:'صفحه مورد نظر یافت نشد'}});
  }

  if(to.meta.requiresAuth === true){
    store.dispatch('checkToken')
  }
  if(to.meta.requiresAuth === true && hasProfile === false && !['Profile','Dashboard'].includes(to.name)){
    next({name:'Profile'});
  }
  if(to.meta.requiresAuth === true && !['Profile','Dashboard'].includes(to.name) && (/^\d+$/.test(store.state.user.name) || /^\d+$/.test(store.state.user.last_name))){
    Toast.warning("لطفا نام و نام خانوادگی خود را اصلاح نمایید.")
    next({name:'Profile'});
  }
  if(to.meta.requiresLogin && store.getters.getToken !== null){
    next({name:'Index'});
  }else if(to.meta.requiresAuth && !store.getters.getToken){
    next({name:'Index'});
  }else{
    next();
  }

});

export default router
